import React, { useState } from 'react';
import Review from './Review';
import Footer from './Footer';
import Logos from './Logos';

const PlaceOrderButton = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [city, setCity] = useState('');
  const [contact, setContact] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();

  const BASE_URL = 'https://node.insuranceadvisors.pk';


    const orderData = { name, email, city, contact };

    try {
      const saveResponse = await fetch(`${BASE_URL}/api/savelife`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(orderData),
      });

      if (saveResponse.ok) {
        const emailResponse = await fetch(`${BASE_URL}/api/sendEmail`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(orderData),
        });

        if (emailResponse.ok) {
          alert('Order placed and email sent successfully!');
          window.location.href = '/our';
        } else {
          console.error('Failed to send email:', emailResponse.statusText);
        }
      } else {
        console.error('Failed to submit data:', saveResponse.statusText);
      }
    } catch (error) {
      console.error('Error submitting data:', error);
    }
  };

  return (
    <div>
 <div className="container-fluid trvl" style={{ marginBottom: '0', paddingBottom: '0' }}>
  <h5>
    <marquee>LIMITED TIME OFFER...Offering upto 10% discount on Life Insurance.</marquee>
  </h5>
</div>

<div className="container col-12" style={{ marginTop: '0', paddingTop: '0' }}>
  <div className="row">
    <div
      className="col-12 col-sm-6 mb-0 px-0"
      style={{
        marginTop: '0',
        paddingTop: '0',
      }}
    >
      <img
        src="./assets/img/life.png"
        alt="Life Image"
        className="img-fluid"
        style={{
          height: '570px',
          width: '100%',
          marginTop: '0',
          paddingTop: '0',
        }}
      />
    </div>
  {/* </div> */}
{/* </div> */}


          {/* Form Column */}
          <div className="col-12 col-sm-6">
            <div className="card-heading text-center text-sm-start mb-4">
              <h1 className="title">Life Insurance Form</h1>
              <p id="p_1" className="d-block d-sm-none">
                "Secure your future, protect your loved ones."
              </p>
              {/* <p id="p_1" className="d-block d-sm-none">
                Contact Insurance Advisors, where peace of mind begins.
              </p> */}
            </div>
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="form-row">
                  <label className="form-label">Full name</label>
                  <input
                    className="form-control"
                    type="text"
                    name="name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Enter your Full Name"
                    required
                  />
                </div>
                <div className="form-row">
                  <label className="form-label">Email address</label>
                  <input
                    className="form-control"
                    type="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="example@email.com"
                    required
                  />
                </div>
                <div className="form-row">
                  <label className="form-label">Contact Number</label>
                  <input
                    className="form-control"
                    type="number"
                    name="contact"
                    value={contact}
                    onChange={(e) => setContact(e.target.value)}
                    placeholder="0321**"
                    required
                  />
                </div>
                <div className="form-row mb-4">
                  <label className="form-label">Enter Your City</label>
                  <input
                    className="form-control"
                    type="text"
                    name="city"
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                    placeholder="Enter your City Name"
                    required
                  />
                </div>
                <div className="text-center text-sm-start">
                  <div style={{display:'flex', alignItems:'center', justifyContent:'center' }}>
                  <button className="btn btn-danger" type="submit">
                   Confirm Order
                  </button> </div><br/>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <Logos></Logos>
      <Review />

      <br></br>
      
      <div id="ss">
      <div class="insurance-wrapper">
    <h2>TYPES OF LIFE INSURANCE</h2>
    <p class="subheading">Ensure your loved ones' future is secure with our life insurance policies tailored to meet your specific needs.</p>
    
    <div class="cards-wrapper">
        <div class="insurance-card">
            <div class="card-icon"><i class="fas fa-user-lock"></i></div>
            <h3>Term Life Insurance</h3>
            <p>"Protect your family financially with Term Life Insurance. Provides coverage for a specified period, ensuring peace of mind and financial security."</p>
        </div>
        <div class="insurance-card">
            <div class="card-icon"><i class="fas fa-leaf"></i></div>
            <h3>Whole Life Insurance</h3>
            <p>"Get lifelong protection with Whole Life Insurance. Combines insurance coverage with a savings component, ensuring lasting benefits for your family."</p>
        </div>
        <div class="insurance-card">
            <div class="card-icon"><i class="fas fa-chart-line"></i></div>
            <h3>Universal Life Insurance</h3>
            <p>"Stay flexible with Universal Life Insurance. Offers adjustable premiums and savings components to match your changing needs over time."</p>
        </div>
    </div>
</div>
</div>



      <br></br>
      <Footer />
    </div>
  );
};

export default PlaceOrderButton;
